<wiz-vgroup width="100%" height="100%" padding="0px">
  
  <wiz-hgroup height="40px" verticalAlign="center" gap="0">
    <!-- <wiz-label #kindLbl width="100%" class="smallTitleLabel"></wiz-label> -->

    <wiz-icon #icoSelect [visible]="showSelect"
      (click)="askForSelect($event)" 
      style="cursor: pointer; font-size: 20px" tooltipPlacement="right"
      [wizTooltip]="'$.freedata.form.choose.$'">edit</wiz-icon>

    <wiz-icon
      (click)="askForAdd()" [visible]="showAdd" [wizDisabled]="!mayAdd()"
      style="cursor: pointer; font-size: 20px" tooltipPlacement="right" 
      [wizTooltip]="'$.form.new.item.$'">add</wiz-icon>
      
      <!--  [visible]="mayAdd()" -->

    <wiz-icon #icoDelete [visible]="showDelete  && mayDelete()"
      (click)="askForDelete()" [wizDisabled]="!mayDelete()"
      style="cursor: pointer; font-size: 20px" tooltipPlacement="right"
      [wizTooltip]="'$.form.delete.item.$'">delete</wiz-icon>

    <wiz-icon #icoUnselect [visible]="!!currentWidgetLine && showRevert"
    (click)="askForUnselect()"
    style="cursor: pointer; font-size: 20px" tooltipPlacement="right"
    [wizTooltip]="'$.common.unselect.$'">cancel</wiz-icon>

    <wiz-icon #icoClone [visible]="showAdd && !!currentWidgetLineExist" [wizDisabled]="!mayAdd()"
    (click)="askForClone()"
    style="cursor: pointer; font-size: 20px" tooltipPlacement="right"
    [wizTooltip]="'$.common.clone.$'">duplicate</wiz-icon>

    <!-- petits boutons -->
    <wiz-hgroup width="100%" [horizontalAlign]="'end'" [verticalAlign]="'center'" 
    [visible]="(creationMode || !!currentWidgetLine) && specifMode && hasUpdate"
    style="padding: 5px; padding-right: 15px !important;">
      <wiz-icon class="basicIcon bigGreen hoversave" style="cursor: pointer;" [wizTooltip]="'$.common.save.modification.$'" 
        tooltipPlacement="top" 
        (click)="doValid($event)"
        [wizDisabled]="saveDisabled  || !hasUpdate"><mat-icon>check_circle</mat-icon></wiz-icon>
      <wiz-icon class="basicIcon black hoversave" style="cursor: pointer;" [wizTooltip]="'$.common.cancel.modification.$'" 
        tooltipPlacement="top" 
        (click)="doCancel($event)"><mat-icon>cancel</mat-icon></wiz-icon>
    </wiz-hgroup>  

    <wiz-hgroup width="100%" *ngIf="(creationMode || !!currentWidgetLine) && !specifMode" [horizontalAlign]="'end'" [verticalAlign]="'end'" padding="5px">
      <wiz-button
        #btnSave
        (wizClick)="doValid($event)"
        [wizDisabled]="saveDisabled || !hasUpdate"
        [wizLabel]="'$.common.save.modification.$'"
        [wizIcon]="'icon-arrow-right'"
        [iconPlacement]="'right'"
      ></wiz-button>
      <wiz-button
        #btnCancel
        (wizClick)="doCancel($event)"
        class="cancel-button"
        [wizIcon]="'icon-arrow-left'"
        [wizLabel]="'$.common.cancel.modification.$'"
      ></wiz-button>
      </wiz-hgroup>
  </wiz-hgroup>
  <!-- [visible]="creationMode || !!currentWidgetLine" -->
  <wiz-vgroup #argsZone width="100%" height="100%" wizOverflow="auto" 
   [wizDisabled]="!mayUpdate()">
    <baseline-gridster #baselineGridster wizDragDrop [wizDropEnabled]="true" width="100%" height="100%"
                  [model]="model" 
                  [widget]="widget"
                  [fei]="fei"
                  [context]="context"
                  [restrictSet]="restrictSet"
                  [hiddenGroups]="hiddenGroups"
                  [widgets]="widgetItems" 
                  [templatingMode]="false"></baseline-gridster>

    <wiz-vgroup width="100%" height="100%" [visible]="showNextStep"> <!-- showNextStep() && hasNextStepFei()" -->
      <ng-container #gridInjector style="width: 100%; height: 100%;"></ng-container>

      <!-- <next-step-pivot-component
      #agNextStep
      width="100%"
      height="100%"
      [uid]="'agNextStep'"
      [pivotMode]="false"
      [templatingMode]="false"></next-step-pivot-component>[visible]="hasNextStepFei()" -->
    </wiz-vgroup>

      
  </wiz-vgroup>
</wiz-vgroup>
